export type Mode = "ACQ" | "DIV"
export type InterestKind = "leasehold" | "mineral"
// Blank is a first-class value (some rows are legitimately null); a fresh row
// starts blank so we never stamp a value the user didn't pick. "Open" applies
// to mineral acquisitions only (unleased — full royalty).
export type InterestType = "" | "PT" | "HBP" | "Open"

export interface RowState {
  id: string
  mode: Mode
  transaction_date: string // YYYY-MM-DD
  str: string
  county: string
  net_acres: string
  nri_percent: string // ACQ
  nri_assigned_percent: string // DIV
  arti: boolean // DIV
  override_orri: boolean // DIV
  manual_orri_percent: string // DIV
  interest_type: InterestType // detail
  counterparty: string
  depths: string
  price: string
  book_page: string
  expiration_date: string // ACQ + PT only (YYYY-MM-DD)
  orri_640: string // leasehold ACQ
  royalty: string // mineral ACQ, fraction (1.00 = 100%); ignored when Open
  legal_desc: string // mineral
  ogl_lessor: string // mineral ACQ PT/HBP
  ogl_lessee: string
  ogl_date: string // YYYY-MM-DD
  ogl_term: string
  ogl_book_page: string
  notes: string
  expanded: boolean
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10)
}

export function makeEmptyRow(): RowState {
  return {
    id: crypto.randomUUID(),
    mode: "ACQ",
    transaction_date: todayIso(),
    str: "",
    county: "",
    net_acres: "",
    nri_percent: "",
    nri_assigned_percent: "",
    arti: false,
    override_orri: false,
    manual_orri_percent: "",
    interest_type: "",
    counterparty: "",
    depths: "",
    price: "",
    book_page: "",
    expiration_date: "",
    orri_640: "",
    royalty: "",
    legal_desc: "",
    ogl_lessor: "",
    ogl_lessee: "",
    ogl_date: "",
    ogl_term: "",
    ogl_book_page: "",
    notes: "",
    expanded: false,
  }
}
